/**************************************************
 * Nombre:       ListaMenu
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {ButtonBase, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {useAnimate} from "framer-motion";
import {useEffect, useState} from "react";
import ScrollBar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import {useLocation, useNavigate} from "react-router";
import {useMediaQuery} from "@mui/system";


const ListaMenu = ({open, seccionesProcesadas, setOpen}) => {
    const sCell = useMediaQuery((theme) => theme.breakpoints.only('xs'))
    const masSM = useMediaQuery(theme.breakpoints.up('md'))
    const navigate = useNavigate()
    const location = useLocation()
    const [scope, animate] = useAnimate()
    const [opaco, setOpaco] = useState(1)

    useEffect(() => {

        if (scope.current && masSM){
            setOpaco(0)
            animate(scope.current, {x: -200, transitionDuration: 0})
            setTimeout(() => {
                setOpaco(1)
                if (scope.current){
                    animate(scope.current, {x: 1, transitionDuration: 0})
                }

            }, 500)
        }

    }, [open]);
    return (
        <ScrollBar dir={'rigth'} options={{suppressScrollX: true, maxScrollbarLength: 150}}
                   style={{width: open ? '112%' : '170%', marginRight: -24, maxHeight: open ? '74vh' : '84vh',}}>
            <Grid
                ref={scope}
                container
                size={12}
                sx={{opacity: opaco, pr: 3}}
            >

                {seccionesProcesadas.map((it, index) => {
                    return (
                        <Grid key={`ES${index}`} container spacing={0} size={12} sx={{marginTop: open ? 5 : 3,}}>
                            <Grid container size={12} justifyContent={open ? 'flex-start' : 'center'}>
                                <Typography sx={{fontSize: open ? 12 : 16, fontWeight: 800, marginBottom: 1}}>
                                    {open ? it.categoria.toUpperCase() : '...'}
                                </Typography>
                            </Grid>

                            {it.secciones.map((sec, index) => {
                                return (

                                    <ButtonBase
                                        key={`we${index}`}
                                        onClick={() => {
                                            if (sCell) {
                                                setTimeout(() => {
                                                    setOpen(false)
                                                }, 600)
                                            }
                                            navigate(sec.camino)
                                        }
                                        }
                                        sx={{
                                            width: '100%',
                                            py: 1.5,
                                            borderRadius: 2,
                                            backgroundColor: location.pathname === sec.camino ? theme.palette.primary.main : '',
                                            transition: "all .2s ease-in-out",
                                            '&:hover': {
                                                backgroundColor: location.pathname === sec.camino ? theme.palette.primary.main : theme.palette.primary.main + 20,
                                                color: theme.palette.primary.main
                                            }
                                        }}>
                                        <Grid container size={12}>
                                            <Grid container justifyContent={'center'} size={open ? 3 : 12}>
                                                <sec.icono sx={{
                                                    width: 22,
                                                    height: 22,
                                                    fill: location.pathname === sec.camino ? '#fff' : theme.palette.info.main
                                                }}/>
                                            </Grid>
                                            {open &&
                                                <Grid container size={9}>
                                                    <Typography sx={{
                                                        fontSize: 14, fontWeight: 500,
                                                        color: location.pathname === sec.camino ? '#fff' : theme.palette.info.main
                                                    }}>
                                                        {sec.nombre}
                                                    </Typography>
                                                </Grid>
                                            }
                                        </Grid>
                                    </ButtonBase>

                                )
                            })}

                        </Grid>
                    )
                })}


            </Grid>
        </ScrollBar>
    )

}
export default ListaMenu

